var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-date-filter-holder" },
    [
      _c("v-datepicker-public", {
        ref: "picker",
        attrs: { label: _vm.label, name: _vm.name, value: _vm.date },
        on: { input: _vm.inputHandler }
      }),
      _vm._v(" "),
      this.date
        ? _c("div", { staticClass: "v-date-filter__date-controls" }, [
            _c("span", { on: { click: _vm.prev } }, [
              _c("i", { staticClass: "fa fa-angle-left" })
            ]),
            _vm._v(" "),
            _c("span", { on: { click: _vm.next } }, [
              _c("i", { staticClass: "fa fa-angle-right" })
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c1cec4a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1cec4a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VDateFilterPublic.vue
// module id = 472
// module chunks = 1